exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".re-open-case-text {\r\n    color: #04ad30 !important;\r\n}\r\n\r\n.suspend-case-text {\r\n    color: #F1C40F !important;\r\n}\r\n.close-case-text {\r\n    color: #ed6b75 !important;\r\n}\r\n\r\n.re-open-case-text:hover, .suspend-case-text:hover, .close-case-text:hover {\r\n    color: white !important;\r\n}\r\n\r\ndiv.item-head div.item-details h4.item-name {\r\n    font-weight: 600;\r\n    color: #000000;\r\n}\r\n\r\ndiv.item-head div.item-details h4.item-name small {\r\n    font-weight: normal;\r\n    font-style: italic;\r\n}\r\n.tabbable-line > .tab-content {\r\n    padding: 0px 0px;\r\n}\r\n.page-content-row .page-sidebar {\r\n    width: 174px;\r\n    min-width: 174px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/case/details/case-details.component.css
// module id = 975
// module chunks = 1